// core
import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';

// services
import {UtilsService} from '../utils/utils.service';
import {PasswordValidation} from '../shared/services/password-validation';
import {UserRegistrationServiceService} from '../user-registration/service/user-registration-service.service';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {TranslateService} from '@ngx-translate/core';

// constants
import {AppConstants} from '../utils/constants';
import {ConfirmationModal} from '../shared/dialogs/confirmation-modal/confirmation-modal.component';
import {map} from 'rxjs/operators';

// components

@Component({
    selector: 'app-reset-password',
    templateUrl: './reset-password.component.html',
    styleUrls: ['./reset-password.component.scss'],
    standalone: false
})
export class ResetPasswordComponent implements OnInit {
  public token: string;
  public form: UntypedFormGroup;
  bsModalRef: BsModalRef;

  constructor(private activatedRoute: ActivatedRoute,
              private formBuilder: UntypedFormBuilder,
              private route: Router,
              private userRegistrationService: UserRegistrationServiceService,
              private _utilsService: UtilsService,
              private _translateService: TranslateService,
              private _modalService: BsModalService) {
    this.form = formBuilder.group({
      password: [
        {
          value: '',
          disabled: false
        },
        Validators.compose([
          Validators.required,
          Validators.pattern(this._utilsService.getPasswordRegex()),
          Validators.minLength(8)
        ])
      ],
      repeatPassword: [
        {
          value: '',
          disabled: false
        },
        Validators.required
      ],
    }, {
      validator: PasswordValidation.MatchPassword('password', 'repeatPassword')
    });
  }

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe(params => {
      this.token = params['token'];
      this._utilsService.setDefaultLanguage(params['language']);
    });
  }

  public getForm() {
    return this.form;
  }

  save(formValues) {
    formValues.token = this.token;
    this.userRegistrationService.resetPassword(formValues).pipe(
      map((response) => {
        this._openConfirmationModal();
      }, error => {
        this.route.navigate([AppConstants.error]);
      })
    ).subscribe();
  }

  private _openConfirmationModal() {
    this.bsModalRef = this._modalService.show(ConfirmationModal);
    this._translateService.get('You have successfully reset your password').subscribe((res: string) => {
      this.bsModalRef.content.confirmationMessage = res;
    });
    this._modalService.onHide.subscribe(res => this._utilsService.logout());
  }
}
